import React, { useState } from 'react';
import { useLang } from '../contexts/LanguageContext';
import { useSiteConfig, pickI18n } from '../contexts/SiteConfigContext';

const Pricing = ({ hideHeader = false }) => {
  const { lang } = useLang();
  const { config } = useSiteConfig();
  const cats = (config.pricing || []).filter((c) => c.visible !== false);
  const colors = config.identity?.colors || {};
  const [active, setActive] = useState(0);

  const tagText = lang === 'de' ? 'Unsere Preise' : lang === 'ar' ? 'أسعارنا' : 'Our Pricing';
  const titleText =
    lang === 'de' ? 'Transparente Preise für jeden Service'
    : lang === 'ar' ? 'أسعار شفافة لكل خدمة'
    : 'Transparent Prices for Every Service';
  const currency = '€';
  const safeIdx = Math.min(active, Math.max(0, cats.length - 1));

  return (
    <section
      id="pricing"
      className="relative py-24 lg:py-32"
      style={{ background: colors.bg_light || '#fdf5f7' }}
    >
      <div className="max-w-5xl mx-auto px-6 lg:px-10">
        {!hideHeader && (
          <div className="text-center mb-16">
            <p
              className="text-xs md:text-sm mb-4 tracking-[0.3em] uppercase font-medium"
              style={{ color: colors.accent || '#b54e7d' }}
            >
              {tagText}
            </p>
            <h2
              className="font-display"
              style={{
                color: colors.text_dark || '#5a1d3b',
                fontSize: 'clamp(1.875rem, 3vw, 2.75rem)',
                fontWeight: 500,
              }}
            >
              {titleText}
            </h2>
            <div
              className="w-16 h-px mx-auto mt-8 opacity-40"
              style={{ backgroundColor: colors.primary || '#c4477a' }}
            />
          </div>
        )}

        {cats.length === 0 && (
          <p className="text-center text-gray-500">—</p>
        )}

        {cats.length > 0 && (
          <>
            <div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-12">
              {cats.map((c, idx) => {
                const isActive = safeIdx === idx;
                return (
                  <button
                    key={c.id}
                    onClick={() => setActive(idx)}
                    className="px-6 md:px-7 py-3 rounded-full text-sm md:text-base font-medium transition-all duration-300"
                    style={
                      isActive
                        ? { backgroundColor: colors.primary || '#c4477a', color: '#fff' }
                        : { backgroundColor: '#fff', color: colors.text_dark || '#5a1d3b', border: '1px solid #f6d4de' }
                    }
                  >
                    {pickI18n(c.name, lang)}
                  </button>
                );
              })}
            </div>

            <div
              className="bg-white rounded-2xl p-8 md:p-12"
              style={{ boxShadow: '0 1px 3px rgba(196, 71, 122, 0.06), 0 8px 24px -10px rgba(196, 71, 122, 0.12)' }}
            >
              <div className="grid md:grid-cols-2 gap-x-12 gap-y-1">
                {(cats[safeIdx]?.items || []).map((it, i) => (
                  <div
                    key={i}
                    className="flex items-baseline gap-3 py-4 border-b border-pink-100/70 last:border-0"
                  >
                    <span className="text-gray-800 font-medium text-base">
                      {pickI18n(it.name, lang)}
                    </span>
                    <span className="flex-1 border-b border-dotted border-pink-200/80 mx-2 mb-1.5" />
                    <span
                      className="font-display text-lg whitespace-nowrap"
                      style={{ color: colors.primary || '#c4477a', fontWeight: 600 }}
                    >
                      {it.price} {currency}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default Pricing;
